interface EnvironmentVariables extends ImportMetaEnv {
  VITE_WOWI_SHOP_PATH_PREFIX: string;
  VITE_CUSTOM_ENV: "prod" | "dev";
  VITE_DEV_BACKEND_BASE_URL: string;
}

export const APP_ENV: EnvironmentVariables = {
    VITE_WOWI_SHOP_PATH_PREFIX: import.meta.env.VITE_WOWI_SHOP_PATH_PREFIX || "/mietershop",
    VITE_CUSTOM_ENV: import.meta.env.VITE_CUSTOM_ENV || "dev",
    VITE_DEV_BACKEND_BASE_URL: import.meta.env.VITE_DEV_BACKEND_BASE_URL || "https://integration.td-wowi-mietershop.i22hosting.de/mietershop-integration",
    ...import.meta.env,
}